// src/data/calculator-data.ts
import type { Bilingual, CalcUnit, Frequency } from "@/types/calculator";

export const CALC_UNITS: CalcUnit[] = [
  { key: "villa-a", name: { ar: "فيلا مستقلة — نموذج A — ٤٥٠م²", en: "Standalone Villa — Type A — 450 m²" }, priceEGP: 12_500_000 },
  { key: "town-b", name: { ar: "تاون هاوس — نموذج B — ٢٢٠م²", en: "Townhouse — Type B — 220 m²" }, priceEGP: 8_400_000 },
  { key: "apt-c", name: { ar: "شقة فاخرة — نموذج C — ١٨٠م²", en: "Luxury Apartment — Type C — 180 m²" }, priceEGP: 5_800_000 },
];

export const FREQUENCIES: Frequency[] = [
  { key: "monthly", label: { ar: "شهري", en: "Monthly" }, perYear: 12 },
  { key: "quarterly", label: { ar: "ربع سنوي", en: "Quarterly" }, perYear: 4 },
  { key: "biannual", label: { ar: "نصف سنوي", en: "Bi-annual" }, perYear: 2 },
];

/** Month labels for the schedule, indexed from contract signing (fixed base). */
export const SCHEDULE_MONTHS: Bilingual[] = [
  { ar: "عند التعاقد", en: "On signing" },
  { ar: "نوفمبر ٢٠٢٤", en: "Nov 2024" },
  { ar: "ديسمبر ٢٠٢٤", en: "Dec 2024" },
  { ar: "يناير ٢٠٢٥", en: "Jan 2025" },
  { ar: "فبراير ٢٠٢٥", en: "Feb 2025" },
  { ar: "مارس ٢٠٢٥", en: "Mar 2025" },
];

export const SAVED_PLANS: Bilingual[] = [
  { ar: "فيلا A · ١٠٪ مقدم · ٥ سنوات", en: "Villa A · 10% down · 5 years" },
  { ar: "شقة C · ٢٠٪ مقدم · ٧ سنوات", en: "Apt C · 20% down · 7 years" },
];
